import React from 'react';

import { TextField } from 'Containers/App/types';
import RichText from 'Shared/RichText';
import { RichTextStyleWrapperProps } from 'Shared/RichText/styled';
import Text from 'Shared/Text';
import { FieldDataTypes } from 'Types/entities';
import { toDollars } from 'Utils/helpers';

interface FbsDetailProps {
  type?: FieldDataTypes;
  data?: string | number | React.ReactNode;
  richTextProps?: {
    maxHeaderSize?: number;
    richTextStyling?: RichTextStyleWrapperProps;
    useStylingWrapper?: boolean;
  };
}

const FbsDetail = ({ type, data, richTextProps }: FbsDetailProps) => {
  switch (type) {
    case FieldDataTypes.STRING:
    case FieldDataTypes.TEXTFIELD:
      return data;
    case FieldDataTypes.RICHTEXT:
      return <RichText inlineParagraphs={false} field={data as TextField} {...richTextProps} />;
    case FieldDataTypes.REFERENCE:
      return <Text field={`fbs_tokens.${data}` as TextField} />;
    case FieldDataTypes.USD:
      return toDollars(data?.toString());
    default:
      return data || ' ';
  }
};

export default FbsDetail;
